export default {
  main: {
    site_id: 1326,
    enableWorldCup: true,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    terminalId: 35749,
    disableCheckTicketAfterLogin: true,
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketTimer: true,
    timeFormat: "HH:mm",
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    signInType: "email",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    staffPassword: "0",
    websitePasswordHash: "277c5f7a7fccdcc770c8c9374c8b50a8e18b97dbc97f593c93e2945514a64c9c",

    termsAndConditions: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: true,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,

    availableLanguages: {
      "@replace": true,
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
      fra: {
        short: "FR",
        name: "Fra",
        order: 14,
      },
      chi: {
        short: "CH",
        name: "Chi",
        order: 9,
      },
    },
  },
  env: {
    lang: "spa",
  },
  splitScreen: {
    enabled: false,
  },
  verification: {
    enabled: true,
    required: true,
    externalValidation: false,
    payerValidation: false,
    findPlatformPlayer: true,
    amountValidation: false,
    betCreation: false,
    nameMasking: false,
    type: 'DNI',
    defaultCountryCode: 'PER',
    partner: 'tiorico',
    docTypes: [
      {
        name: 'DNI',
        type: 'DNI',
        default: true,
      }
    ],
  },
  terminal: {
    signInToAdmin: true,
  },
  upperScreen: {
    statisticsLive: false,
    statisticsPrematch: true,
    liveStreaming: true,
    liveAnimations: true,
  },
  historyTabConfig: [
    {
      icon: "sports-section",
      title: "Sport",
    },
    {
      icon: "casino-7",
      title: "Casino",
    },
  ],
  sportsbook: {
    enableBoostedOdds: false,
    enablePredefinedMultiples: false,
    enableBannerAnimation: true,
  },
  userSection: {
    sections: ["betHistory"],
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
    },
    {
      url: "betting/prematch/all",
      name: "Sports",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  betslip: {
    enableCounterOffer: false,
    enableBookingBet: true,
    disableCounterOfferOnLive: false,
    enableBookingId: true,
    bookingBetBalanceMaxLimit: 99999999,
    betDetailsOrder: ["total_odd", "stake_without_tax", "total_stake", "total_win"],
  },
  defaultTerminalParams: { pid: 1326, tid: 35749, token: "suECGw==", currency: "PEN" },
};
